import React, { useEffect, useState } from "react";
import axios from "axios";
import "./LinkedIn.css";

const LinkedIn = () => {
  const [token, setToken] = useState(localStorage.getItem("linkedinToken") || "");
  const [campaignName, setCampaignName] = useState("");
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [forms, setForms] = useState([]);
  const [selectedForm, setSelectedForm] = useState("");
  const [leads, setLeads] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");

  // Helper function to extract numeric ID from URN string
  const extractOrgId = (urn) => {
    if (!urn) return "";
    const parts = urn.split(":");
    return parts[parts.length - 1]; // last part is numeric ID
  };

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== "https://leadbankapi.gensparc.com") return;
      const { provider, accessToken } = event.data;
      if (provider === "linkedin" && accessToken) {
        localStorage.setItem("linkedinToken", accessToken);
        setToken(accessToken);
        setStatusMessage("Successfully logged in with LinkedIn.");

        try {
          const response = await axios.get("https://leadbankapi.gensparc.com/api/linkedin/ad-accounts", {
            headers: { Authorization: `Bearer ${accessToken}` },
          });
          setAdAccounts(response.data.elements || []);
        } catch (error) {
          console.error("Error fetching ad accounts after login:", error);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    const fetchAdAccounts = async () => {
      if (!token) return;
      try {
        const response = await axios.get("https://leadbankapi.gensparc.com/api/linkedin/ad-accounts", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdAccounts(response.data.elements || []);
      } catch (error) {
        console.error("Error fetching ad accounts:", error);
      }
    };

    if (token) {
      fetchAdAccounts();
    }
  }, [token]);

  useEffect(() => {
    const fetchForms = async () => {
      if (!selectedOrgId) return;

      console.log("Fetching forms for org ID:", selectedOrgId); // sanity check

      try {
        const response = await axios.get(`https://leadbankapi.gensparc.com/api/linkedin/forms/${selectedOrgId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForms(response.data.forms || []);
      } catch (error) {
        console.error("Error fetching forms:", error);
      }
    };

    if (selectedOrgId) {
      fetchForms();
    }
  }, [selectedOrgId, token]);

  useEffect(() => {
    const fetchLeads = async () => {
      if (!selectedForm) return;
      try {
        const response = await axios.get(`https://leadbankapi.gensparc.com/api/linkedin/leads/${selectedForm}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLeads(response.data || []);
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    };

    fetchLeads();
  }, [selectedForm, token]);

  const openLinkedInLoginPopup = () => {
    const popup = window.open("https://leadbankapi.gensparc.com/api/linkedin/auth", "_blank", "width=600,height=600");
    const checkPopupClosed = setInterval(() => {
      if (popup && popup.closed) {
        clearInterval(checkPopupClosed);
        const newToken = localStorage.getItem("linkedinToken");
        if (newToken) {
          setToken(newToken);
          setStatusMessage("Successfully logged in.");
        } else {
          setStatusMessage("Login failed or was canceled.");
        }
      }
    }, 1000);
  };

  const handleSaveSelection = async () => {
    if (!token || !campaignName || !selectedOrgId || !selectedForm) return;
    try {
      await axios.post(
        "https://leadbankapi.gensparc.com/api/linkedin/save-selection",
        {
          campaignName,
          adAccount: selectedOrgId,
          formId: selectedForm,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatusMessage("Selection saved successfully!");
    } catch (error) {
      console.error("Error saving selection:", error);
      setStatusMessage("Failed to save selection.");
    }
  };

  return (
    <div className="leads-container">
      <h2>LinkedIn Lead Center</h2>
      {!token ? (
        <button className="login-butto" onClick={openLinkedInLoginPopup}>
          Login with LinkedIn
        </button>
      ) : (
        <>
          <p className="status-message">{statusMessage}</p>

          <input
            type="text"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
            placeholder="Enter campaign name"
          />
<select value={selectedOrgId} onChange={(e) => setSelectedOrgId(e.target.value)}>
  <option value="">Select an Organization</option>
  {adAccounts.map((account) => (
    <option key={account.id} value={account.id}>
      {account.name || `Org ${account.id}`}
    </option>
  ))}
</select>


          <select
            value={selectedForm}
            onChange={(e) => setSelectedForm(e.target.value)}
            disabled={!selectedOrgId}
          >
            <option value="">Select a Form</option>
            {forms.map((form) => (
              <option key={form.id} value={form.id}>
                {form.name || `Form ${form.id}`}
              </option>
            ))}
          </select>

          {selectedForm && (
            <div>
              <button onClick={handleSaveSelection}>Save Selection</button>
              <h3>Leads</h3>
              <table className="leads-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Full Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.length > 0 ? (
                    leads.map((lead) => (
                      <tr key={lead.id}>
                        <td>{lead.id}</td>
                        <td>{lead.fullName || "-"}</td>
                        <td>{lead.email || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No leads found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LinkedIn;
